{
  "title": "Дашборд",
  "canvas": "Схема проекта",
  "empty": "Пока нечего показать",
  "emptyLead": "На схеме появятся серверы, публичные IP, файрволы и сети проекта, как только они будут. Начните с создания сервера.",
  "arrange": "Расставить",
  "arrangeTitle": "Расставить всю схему заново?",
  "arrangeLead": "Все объекты встанут на новые места: слева Интернет, в каждой локации — публичные IP и файрволы, затем серверы; справа сети. Расстановка, которую сделали вы и другие, заменится для всех участников проекта.",
  "arrangeConfirm": "Расставить",
  "arrangeSelected": "Расставить выбранные ({{count}})",
  "arrangeSelectedTitle": "Расставить выбранные объекты ({{count}})?",
  "arrangeSelectedLead": "Выбранные объекты встанут по порядку там, где они сейчас; остальные останутся на своих местах. Esc снимает выбор.",
  "readOnlyNote": "На маленьком экране — только просмотр: двигайте, масштабируйте, выбирайте; менять объекты — на их страницах.",
  "viewerNote": "Вы гость в этом проекте: схему можно смотреть, расставляют её владельцы и администраторы.",
  "saveFailed": "Не удалось сохранить новое положение",
  "zoomIn": "Приблизить",
  "zoomOut": "Отдалить",
  "fit": "Показать всё",
  "minimap": "Обзор схемы",
  "legend": {
    "label": "Цвета линий",
    "public": "Публичный доступ",
    "firewall": "Файрвол",
    "private": "Частная сеть",
    "balancer": "Балансировщик к его целям"
  },
  "a11y": {
    "node": "Enter — выбрать, стрелки — передвинуть выбранный объект.",
    "nodeReadOnly": "Enter — выбрать и открыть подробности.",
    "moved": "Сдвинуто: {{direction}}, теперь {{x}}, {{y}}",
    "edge": "Связь",
    "handle": "Точка подключения"
  },
  "kinds": {
    "internet": "Интернет",
    "server": "Сервер",
    "public_ip": "Публичный IP",
    "firewall": "Файрвол",
    "network": "Сеть",
    "volume": "Диск",
    "floating_ip": "Плавающий IP",
    "load_balancer": "Балансировщик"
  },
  "internet": {
    "title": "Интернет",
    "lead": "Публичный трафик",
    "about": "Откуда приходит публичный трафик. Линии от него показывают, какие порты каждого сервера открыты, по правилам применённых к серверу файрволов."
  },
  "server": {
    "cores": "{{count}}\u00a0vCPU",
    "noImage": "Образ удалён",
    "terminal": "Терминал {{name}}",
    "wan": "WAN",
    "noPublic": "Нет публичного адреса",
    "noFirewall": "Нет файрвола",
    "firewalls": "Файрволы: {{names}}",
    "parts": "Что относится к серверу",
    "disks": "Диски",
    "noDisks": "Нет подключённых"
  },
  "chips": {
    "disk": "{{size}}\u00a0ГБ · локальный NVMe",
    "volume": "{{size}}\u00a0ГБ · {{format}}",
    "volumeRaw": "{{size}}\u00a0ГБ · без ФС",
    "backupsOff": "Бэкапы выкл.",
    "backupsWindow": "Бэкапы · окно {{window}}",
    "backupsCopies": "Бэкапы: {{count}} · последний {{last}}",
    "backupsNone": "Бэкапы вкл. · копий пока нет",
    "snapshots": "Снимки: {{count}} · {{size}}\u00a0ГБ · последний {{last}}",
    "iso": "ISO {{name}}",
    "rescue": "Rescue вкл.",
    "protected": "Защищён",
    "rebuildProtected": "Переустановка запрещена",
    "busy": "Занят",
    "placement": "Spread: {{name}}",
    "package": "{{name}}",
    "packageDrift": "{{name}} · изменён вручную"
  },
  "metrics": {
    "label": "Нагрузка за последние 30 минут",
    "cpu": "CPU",
    "network": "Сеть",
    "disk": "Диск IOPS",
    "iops": "чт {{read}} · зп {{write}}",
    "off": "Метрик нет, пока сервер не работает.",
    "error": "Метрики сейчас недоступны.",
    "autopilot": "Автопилот: заполнение памяти и диска",
    "memory": "Память",
    "diskUsage": "Диск"
  },
  "ports": {
    "all": "открыты все порты",
    "none": "закрыто"
  },
  "ip": {
    "assigned": "на {{server}}",
    "free": "Не назначен",
    "unreachable": "Недоступен: не назначен ни одному серверу"
  },
  "firewall": {
    "rules": "Правила: {{inbound}} вх. · {{outbound}} исх.",
    "servers": "Серверов: {{count}}",
    "unused": "Ни к чему не применён"
  },
  "network": {
    "zone": "Зона {{zone}}",
    "subnets": "Подсетей: {{count}}",
    "servers": "серверов: {{count}}"
  },
  "panel": {
    "label": "Выбранный объект",
    "close": "Закрыть подробности",
    "status": "Состояние",
    "type": "Тип",
    "location": "Локация",
    "image": "Система",
    "public": "Публичные адреса",
    "ports": "Открыто в интернет",
    "firewalls": "Файрволы",
    "networks": "Сети",
    "address": "Адрес",
    "family": "Тип адреса",
    "server": "Сервер",
    "reverseDns": "Обратный DNS",
    "rules": "Правила",
    "appliedTo": "Применён к",
    "selectors": "Селекторы меток",
    "range": "Диапазон IP",
    "subnets": "Подсети",
    "attached": "Серверы",
    "routes": "Маршруты",
    "about": "Что это",
    "cost": "Этот объект в месяц",
    "free": "Бесплатно",
    "total": "Весь проект в месяц",
    "costNote": "Без НДС, по прайс-листу; трафик сверх включённого и снимки не учтены.",
    "links": "Где изменить",
    "openServer": "Открыть сервер",
    "power": "Питание",
    "networking": "Адреса и сети",
    "metrics": "Графики нагрузки",
    "openIps": "Открыть IP-адреса",
    "openAssigned": "Открыть {{server}}",
    "editRules": "Изменить правила",
    "applyFirewall": "Серверы и селекторы",
    "openNetwork": "Открыть сеть",
    "subnetsLink": "Подсети",
    "size": "Объём",
    "fileSystem": "Файловая система",
    "device": "Устройство",
    "openVolumes": "Открыть диски",
    "openFloatingIps": "Открыть плавающие IP",
    "openLoadBalancer": "Открыть балансировщик",
    "description": "Описание",
    "placement": "Группа размещения"
  },
  "busy": "Идёт изменение",
  "connect": {
    "hint": "Тяните линию от точки на карточке к подходящей точке: подсветятся только те, что подходят. Свободный диск подключается к точке «Диски» сервера, плавающий IP — к его точке WAN. Выберите линию или диск на сервере, чтобы удалить связь. Shift + щелчок или рамка с Shift выбирают несколько объектов.",
    "slot": "Сеть",
    "refused": "Сюда нельзя подключить",
    "point": {
      "wan": "Точка WAN: {{name}}",
      "slot": "Подключить к сети: {{name}}",
      "joined": "{{name}} в сети {{network}}",
      "ip": "Публичный IP: {{name}}",
      "network": "Вход сети: {{name}}",
      "firewall": "Применить файрвол: {{name}}",
      "fixed": "Точка подключения",
      "disk": "Диски сервера: {{name}}",
      "volume": "Точка диска: {{name}}",
      "floating": "Плавающий IP: {{name}}"
    },
    "accepts": {
      "ip": "Публичный или плавающий IP подключается только к точке WAN сервера.",
      "wan": "К точке WAN подключаются публичный или плавающий IP или файрвол.",
      "slot": "Свободная точка сервера («+ Сеть») подключается ко входу сети.",
      "network": "К сети подключается свободная точка сервера («+ Сеть»).",
      "firewall": "Файрвол подключается только к точке WAN сервера.",
      "volume": "Свободный диск подключается к точке «Диски» сервера.",
      "disk": "К точке «Диски» подключается свободный диск."
    },
    "reasons": {
      "same_object": "Это точка того же объекта.",
      "wrong_point": "Эти точки нельзя соединить.",
      "fixed_point": "Эта точка только показывает существующие связи.",
      "already_connected": "Они уже связаны.",
      "ip_assigned": "IP уже назначен серверу {{server}}. Сначала снимите его там.",
      "ip_blocked": "Провайдер заблокировал этот IP: его нельзя назначить.",
      "other_location": "IP в локации {{ip}}, а сервер — в {{server}}. Публичный IP назначается только серверу своей локации.",
      "server_has_address": "У сервера уже есть {{family}} {{address}}: у сервера один адрес каждого типа. Сначала снимите его.",
      "server_busy": "{{server}} сейчас занят: выполняет другое действие или меняет состояние.",
      "network_limit": "Сервер уже в {{max}} сетях — это максимум.",
      "network_zone": "В сети нет подсети в сетевой зоне сервера ({{zone}}). Добавьте подсеть на странице сети.",
      "firewall_limit": "К серверу уже применено {{max}} файрволов — это максимум.",
      "volume_attached": "Диск уже подключён к {{server}}. Сначала отключите его там.",
      "volume_creating": "Диск {{volume}} ещё создаётся.",
      "volume_location": "Диск в локации {{volume}}, а сервер — в {{server}}. Диск подключается только к серверу своей локации.",
      "volume_limit": "К серверу уже подключено {{max}} дисков — это максимум.",
      "floating_zone": "Плавающий IP в сетевой зоне {{ip}}, а сервер — в {{server}}. Адрес направляется только на серверы своей зоны.",
      "resource_busy": "{{name}}: сейчас выполняется другое изменение. Дождитесь его конца."
    },
    "volumeChip": "Диск {{name}} ({{size}}) на {{server}}"
  },
  "power": {
    "assignWarning": "Hetzner назначает публичный IP только выключенному серверу. {{server}} работает: сначала он остановится, потом получит IP. Пока сервер выключен, его сервисы недоступны.",
    "unassignWarning": "Hetzner снимает публичный IP только с выключенного сервера. {{server}} работает: сначала он остановится. Пока сервер выключен, его сервисы недоступны.",
    "keepOpen": "Шаги идут по очереди, пока открыт дашборд: не закрывайте страницу до конца.",
    "legend": "Как остановить {{server}}",
    "shutdown": "Завершить работу штатно",
    "shutdownHint": "Система получает сигнал ACPI и выключается сама; ждём до 3 минут.",
    "powerOff": "Выключить питание сразу",
    "powerOffHint": "Как выдернуть вилку: несохранённые данные могут потеряться.",
    "powerOnAfter": "Включить сервер снова, когда всё будет готово"
  },
  "assign": {
    "title": "Назначить {{address}} серверу {{server}}",
    "lead": "Адрес начнёт вести на этот сервер. Открытые порты определяют файрволы сервера.",
    "submit": "Назначить",
    "submitCycle": "Выключить, назначить и включить",
    "submitOff": "Выключить и назначить"
  },
  "attach": {
    "title": "Подключить {{server}} к сети {{network}}",
    "lead": "Сервер получит частный адрес в подсети своей сетевой зоны ({{zone}}).",
    "subnets": "Подсети зоны",
    "address": "Частный адрес",
    "auto": "Автоматически",
    "autoHint": "Провайдер выберет свободный адрес.",
    "fixed": "Указать адрес",
    "ip": "Адрес сервера в сети",
    "ipHint": "Например, {{example}} — первый свободный.",
    "alias": "Дополнительные адреса (alias IP)",
    "aliasHint": "Необязательно. До {{max}} адресов через запятую, в тех же подсетях.",
    "submit": "Подключить",
    "problems": {
      "invalid": "Это не IPv4-адрес.",
      "outside": "Адрес вне подсетей зоны {{zone}}.",
      "reserved": "Это адрес сети, роутера или широковещательный адрес подсети.",
      "taken": "Этот адрес в сети уже занят.",
      "duplicate": "Адрес указан дважды.",
      "tooMany": "Не больше {{max}} дополнительных адресов."
    }
  },
  "apply": {
    "title": "Применить файрвол {{firewall}}",
    "lead": "Входящих правил: {{inbound}}. Всё, что они не разрешают, будет отброшено.",
    "target": "К чему применить",
    "server": "Только к серверу {{server}}",
    "serverHint": "Файрвол будет фильтровать входящий трафик этого сервера.",
    "selector": "К серверам по селектору меток",
    "selectorHint": "Действует на все серверы с такими метками — и на новые тоже.",
    "selectorField": "Селектор меток",
    "suggestions": "Метки сервера:",
    "matches": "Сейчас подходят: {{names}}",
    "matchesNone": "Сейчас не подходит ни один сервер.",
    "invalid": "Не удаётся прочитать селектор: например, role=web или env in (prod,staging).",
    "viaSelector": "Файрвол уже действует на этот сервер через селектор {{selector}}. Прямое применение сохранит его, даже если метки сервера сменятся.",
    "noPublic": "У сервера нет публичного адреса: правилам пока нечего фильтровать.",
    "submit": "Применить"
  },
  "disconnect": {
    "unassign": {
      "title": "Снять {{address}} с {{server}}?",
      "action": "Снять IP",
      "actionCycle": "Выключить и снять IP",
      "loses": "{{server}} перестанет отвечать на {{address}}.",
      "keeps": "IP останется в проекте свободным и продолжит оплачиваться, пока вы его не удалите."
    },
    "detach": {
      "title": "Отключить {{server}} от сети {{network}}?",
      "action": "Отключить",
      "loses": "{{server}} потеряет частный адрес {{ip}}.",
      "traffic": "Связь с другими серверами сети {{network}} по частным адресам пропадёт."
    },
    "remove": {
      "title": "Снять файрвол {{firewall}} с {{server}}?",
      "action": "Снять файрвол",
      "rules": "Правила {{firewall}} перестанут действовать на {{server}}.",
      "open": "У {{server}} не останется файрволов: открыты все порты."
    },
    "selector": {
      "title": "Убрать селектор {{selector}} из {{firewall}}?",
      "action": "Убрать селектор",
      "servers": "Файрвол перестанет действовать на все подходящие серверы ({{count}}): {{names}}.",
      "future": "Новые серверы с такими метками тоже не получат его."
    },
    "unassignFloating": {
      "keeps": "Адрес останется в проекте свободным и продолжит оплачиваться, пока вы его не удалите. Выключать сервер не нужно."
    }
  },
  "edge": {
    "label": "Связь: {{from}} → {{to}}",
    "toolbar": "Выбранная связь",
    "remove": "Удалить связь",
    "dismiss": "Скрыть",
    "close": "Снять выделение",
    "failed": "Не удалось: {{error}}"
  },
  "steps": {
    "shutdown": "Завершение работы {{server}}",
    "power-off": "Выключение {{server}}",
    "power-on": "Включение {{server}}",
    "assign-ip": "Назначение {{address}}",
    "unassign-ip": "Снятие {{address}}",
    "attach": "Подключение {{server}} к сети",
    "detach": "Отключение {{server}} от сети",
    "apply-firewall": "Применение {{firewall}}",
    "remove-firewall": "Снятие {{firewall}}",
    "one": "{{step}} · {{percent}}%",
    "of": "Шаг {{n}} из {{count}}: {{step}} · {{percent}}%",
    "attach-volume": "Подключение {{volume}} к {{server}}",
    "detach-volume": "Отключение {{volume}} от {{server}}",
    "assign-floating": "Назначение {{address}} серверу {{server}}",
    "unassign-floating": "Снятие {{address}}"
  },
  "run": {
    "failed": "Провайдер не выполнил действие.",
    "notStopped": "Сервер не выключился за 3 минуты.",
    "restarted": "Сервер снова включён.",
    "assigned": "{{address}} назначен серверу {{server}}",
    "unassigned": "{{address}} снят с {{server}}",
    "attached": "{{server}} подключён к сети {{network}}",
    "detached": "{{server}} отключён от сети {{network}}",
    "applied": "Файрвол {{firewall}} применён: {{target}}",
    "removed": "Файрвол {{firewall}} снят: {{target}}",
    "attachedVolume": "Диск {{volume}} подключён к {{server}}",
    "detachedVolume": "Диск {{volume}} отключён от {{server}}"
  },
  "palette": {
    "title": "Создать",
    "label": "Создать объект на схеме",
    "hint": "Выберите и щёлкните на схеме, куда поставить, или перетащите на схему.",
    "armed": "Щёлкните на схеме, куда поставить: {{kind}}. Esc — отмена.",
    "server": "Сервер",
    "network": "Сеть",
    "firewall": "Файрвол",
    "public_ip": "Публичный IP",
    "floating_ip": "Плавающий IP",
    "volume": "Диск"
  },
  "createMenu": {
    "label": "Создать и подключить",
    "public_ip": "Новый публичный {{family}}",
    "firewall": "Новый файрвол для {{server}}",
    "network": "Новая сеть для {{server}}",
    "serverInNetwork": "Новый сервер в сети {{network}}",
    "serverWithFirewall": "Новый сервер с файрволом {{firewall}}",
    "floating_ip": "Новый плавающий IP для {{server}}",
    "volume": "Новый диск для {{server}}"
  },
  "create": {
    "pending": "Создаётся…",
    "failed": "Не создан",
    "created": "{{name}} создан",
    "network": {
      "title": "Новая сеть",
      "lead": "Частная сеть с первой подсетью. Подключайте к ней серверы линиями от их точки «+ Сеть».",
      "leadConnect": "Частная сеть с первой подсетью; {{server}} подключится к ней сразу после создания.",
      "zoneFixed": "Сетевая зона: {{zone}} — как у {{server}}.",
      "submit": "Создать сеть",
      "submitConnect": "Создать и подключить"
    },
    "firewall": {
      "title": "Новый файрвол",
      "lead": "Правила разрешают входящий трафик; всё остальное отбрасывается.",
      "defaults": "Стандартные входящие правила: SSH (22/tcp) и ICMP отовсюду",
      "defaultsHint": "Остальные правила добавите на странице файрвола.",
      "noRules": "Без правил файрвол закроет весь входящий трафик.",
      "applyTo": "Файрвол сразу применится к {{server}}.",
      "fullForm": "Полная форма с правилами",
      "submit": "Создать файрвол",
      "submitConnect": "Создать и применить"
    },
    "public_ip": {
      "title": "Новый публичный IP",
      "lead": "Адрес в выбранной локации; назначьте его серверу линией к точке WAN.",
      "leadAssign": "Адрес будет создан в локации {{server}} и сразу назначен ему.",
      "family": "Тип: {{family}}",
      "regionFixed": "Локация: {{region}} — как у {{server}}.",
      "submit": "Создать IP",
      "submitAssign": "Создать и назначить"
    },
    "volume": {
      "title": "Новый диск",
      "lead": "Свободный диск в выбранной локации; подключите его к серверу линией к точке «Диски».",
      "leadAttach": "Диск будет создан в локации {{server}} и сразу подключён к нему.",
      "regionFixed": "Локация: {{region}} — как у {{server}}.",
      "submit": "Создать диск",
      "submitAttach": "Создать и подключить",
      "createdOn": "Диск {{name}} создаётся на {{server}}"
    },
    "floating_ip": {
      "title": "Новый плавающий IP",
      "lead": "Адрес числится в выбранной локации; направьте его на сервер зоны линией к точке WAN.",
      "leadAssign": "Адрес будет создан в локации {{server}} и сразу направлен на него.",
      "regionFixed": "Домашняя локация: {{region}} — как у {{server}}.",
      "submit": "Создать IP",
      "submitAssign": "Создать и назначить"
    }
  },
  "volume": {
    "detached": "Не подключён",
    "creating": "Создаётся"
  },
  "floating": {
    "badge": "Плавающий"
  },
  "attachVolume": {
    "title": "Подключить {{volume}} к {{server}}",
    "lead": "Сервер увидит диск как {{device}}. Выключать сервер не нужно.",
    "size": "Объём",
    "noFs": "На диске нет файловой системы: создайте её на сервере (например, mkfs.ext4) и смонтируйте сами.",
    "submit": "Подключить"
  },
  "assignFloating": {
    "title": "Направить {{address}} на {{server}}",
    "moveTitle": "Перенести {{address}} с {{from}} на {{server}}",
    "lead": "Подходит любой сервер сетевой зоны {{zone}}, включённый или выключенный: сервер не останавливается, переключение занимает несколько секунд.",
    "home": "Домашняя локация",
    "leaves": "{{from}} перестанет получать трафик на {{address}}, как только адрес перейдёт на {{server}}.",
    "submit": "Назначить",
    "move": "Перенести"
  },
  "volumeBar": {
    "toolbar": "Выбранный диск",
    "label": "Диск {{volume}} на {{server}}",
    "detach": "Отключить диск"
  },
  "appliance": {
    "label": "Прибор · {{name}}",
    "title": "Управляемый прибор приложения «{{name}}»",
    "drift": "изменён у провайдера",
    "row": "Управляемый прибор",
    "open": "Открыть «{{name}}»"
  }
}
